module.exports = __webpack_public_path__ + "img/logo_FDA.6d36946c.png";